<template>
    <div style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-1">
                        <br>
                        <i class="bi bi-chevron-left" onclick="window.location.href = '/setting'"></i>
                    </div>
                    <div class="col text-center" style="padding-top: 25px;">
                        <h5>退会</h5>
                    </div>
                    <div class="col-1">
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap">
            <br />
            <div class="container" style="margin-top:30px;">
                <br>
                <br>
                <div class="row">
                    <div class="col-1"></div>
                    <div class="col">
                        <div>
                            本当に退会をしてもよろしいですか？<br>
                            退会をする場合は、以下の内容を再度確認の上、退会ボタンを押して下さい。
                        </div>
                    </div>
                    <div class="col-1"></div>
                </div>
                <br>
                <br>
                <div class="row">
                    <div class="col-1"></div>
                    <div class="col">
                        <div class="card" style="background-color: #F2F4F5;font-weight: bold;">
                            <div class="card-body" v-if="!user.is_plan">
                                退会をしてアカウントを削除すると、あなたの入力情報や今までのいいね、マッチング履歴などは全て削除され、二度と復旧をすることはできません。
                            </div>
                            <div class="card-body" v-else>
                                退会をしてアカウントを削除すると、あなたの入力情報や今までのいいね、マッチング履歴などは全て削除され、二度と復旧をすることはできません。
                                <br><br>
                                また、有料会員のお客様は、退会と同時に解約となります。
                                <br><br>
                                更新日前に解約/退会のお手続きをなさった場合、残りの期間についての月割り・日割りでの返金はいたしません。
                            </div>
                        </div>
                    </div>
                    <div class="col-1"></div>
                </div>
                <br>
                <br>
                <div class="row">
                    <div class="col-1"></div>
                    <div class="col">
                        <div class="form-check">
                            <input class="form-check-input-luna" type="checkbox" id="flexCheckUnsubscribe"
                                v-model="is_unsubscribe" />
                            <label class="form-check-label label-box" for="flexCheckUnsubscribe"
                                style="padding-left: 5px;padding-top:6px;">
                                <b>上記の注意事項に同意する</b>
                            </label>
                        </div>
                    </div>
                    <div class="col-1"></div>
                </div>
                <br>
                <!-- 退会理由選択（注意事項同意後に表示） -->
                <template v-if="is_unsubscribe">
                    <div class="row">
                        <div class="col-1"></div>
                        <div class="col">
                            <p style="font-weight: bold;">退会理由をお選びください<br><span style="color: red;">一つ以上必須</span></p>
                            <div v-if="withdrawalReasons.length === 0" style="color: #888;">
                                読み込み中...
                            </div>
                            <div v-for="reason in withdrawalReasons" :key="reason.id" class="form-check" style="margin-bottom: 8px;">
                                <input
                                    class="form-check-input-luna"
                                    type="checkbox"
                                    :id="'reason-' + reason.id"
                                    :value="reason.id"
                                    v-model="selectedReasonIds"
                                />
                                <label
                                    class="form-check-label label-box"
                                    :for="'reason-' + reason.id"
                                    style="padding-left: 5px;padding-top:6px;"
                                >
                                    {{ reason.label_ja }}
                                </label>
                            </div>
                            <div v-if="isOtherSelected" style="margin-top: 8px;">
                                <textarea
                                    v-model="otherText"
                                    class="form-control"
                                    rows="3"
                                    maxlength="1000"
                                    placeholder="その他の退会理由をご記入ください"
                                    style="resize: vertical;"
                                ></textarea>
                            </div>
                        </div>
                        <div class="col-1"></div>
                    </div>
                    <br>
                </template>
                <div class="row justify-content-center">
                    <div class="col-11 text-center">
                        <a type="button" class="btn btn-danger"
                            style="font-size: 14px; padding: 10px 100px;-webkit-appearance: none;appearance: none;border-radius: 50px;"
                            href="/home">
                            退会をやめる
                        </a>
                    </div>
                </div>
                <br>
                <br>
                <div v-if="is_unsubscribe && selectedReasonIds.length === 0" class="row justify-content-center" style="margin-bottom: 8px;">
                    <div class="col-10 text-center">
                        <p style="color: red; margin: 0; font-size: 14px;">退会理由を一つ以上選択してください</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-1"></div>
                    <div class="col">
                        <div class="d-grid gap-2">
                            <button type="button" class="btn btn-luna" style="padding:12px 0;border-radius: 50px;"
                                @click="unsubscribe()" id="on-btn" v-if="is_unsubscribe && selectedReasonIds.length > 0">
                                退会
                            </button>
                            <button type="button" class="btn btn-luna-d disabled" style="padding:12px 0;border-radius: 50px;" id="non-btn"
                                v-else>退会</button>
                        </div>
                    </div>
                    <div class="col-1"></div>
                </div>
                <br>
                <br>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            user: [],
            is_unsubscribe: false,
            is_status_box: false,
            withdrawalReasons: [],
            selectedReasonIds: [],
            otherText: '',
        };
    },
    computed: {
        isOtherSelected() {
            const otherReason = this.withdrawalReasons.find(r => r.is_other);
            return otherReason ? this.selectedReasonIds.includes(otherReason.id) : false;
        },
    },
    methods: {
        async unsubscribe() {
            localStorage.clear()
            const payload = { reason_ids: this.selectedReasonIds };
            if (this.isOtherSelected && this.otherText.trim()) {
                payload.other_text = this.otherText.trim();
            }
            await axios.post("/api/setting/unsubscribe", payload)
                .then((response) => {
                    document.cookie = "uid=;path=/; max-age=0"
                    window.location.href = "/auth?unsubscribed=true"
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast('退会に失敗しました。');
                    }
                })
        },
        async fetchUsers() {
            await axios.get("/api/user/status")
                .then((response) => {
                    this.user = response.data.user
                    this.is_status_box = this.user.is_plan
                    this.is_status_box = true
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast('ユーザーの取得に失敗しました。');
                    }
                })
        },
        async fetchWithdrawalReasons() {
            await axios.get("/api/v2/withdrawal-reasons")
                .then((response) => {
                    this.withdrawalReasons = response.data.reasons ?? []
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    } else {
                        this.$showErrorToast('退会理由の取得に失敗しました。');
                    }
                })
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.fetchUsers()
                        })
                    .catch((error) => {
                        this.$showErrorToast('ユーザーの取得に失敗しました。');
                    })
            }
            else {
                this.fetchUsers()
            }
        }
        else {
            this.fetchUsers()
        }

        this.fetchWithdrawalReasons()
    },
    filters: {
        moment(date) {
            let now = new Date(date)
            let YYYY = now.getFullYear()
            let MM = now.getMonth() + 1
            let DD = now.getDate()

            return YYYY + "年" + MM + "月" + DD + "日"
        },
    }
};
</script>
